import { CustomFieldEntity } from 'shared'
import { EntityValue } from '../types'
import { Space } from 'antd'
import { WithColumn } from './types'
import CIMSLink from '../../CIMSLink'

const EntityCustomFields: React.FC<
  WithColumn<Pick<EntityValue, 'entities' | 'customFieldId'>>
> = ({ entities = [], customFieldId, column }) => {
  return (
    <Space
      key={`${customFieldId}_entities`}
      size="small"
      direction={column ? 'vertical' : undefined}
    >
      {entities.map(({ entityId, label, href }) => {
        const { type } = CustomFieldEntity.fromIdOrFail(entityId)
        return (
          <CIMSLink
            key={`${customFieldId}_${entityId}`}
            external
            tooltip={
              !href ? `There is no recordId associated with this ${type}` : type
            }
            href={href}
          >
            {label}
          </CIMSLink>
        )
      })}
    </Space>
  )
}

export default EntityCustomFields
